// Header & Footer – used across the app when Arabic is selected
export const sharedTranslations = {
  en: {
    header: {
      home: 'Home',
      aboutUs: 'About Us',
      ourPackages: 'Our Packages',
      locations: 'Locations',
      contact: 'Contact',
      bookNow: 'Book Now',
      allLocations: 'All Locations',
      sofiaMladost: 'Sofia, Mladost',
      sofiaNsa: 'Sofia, NSA',
      plovdiv: 'Plovdiv',
      sofiaBoyana: 'Sofia, Boyana',
      kranevo: 'Kranevo',
    },
    footer: {
      championMaker: 'Champion Maker',
      description: 'A Bulgaria-based company specializes in organizing sports training camps throughout the country.',
      links: 'Links',
      aboutUs: 'About Us',
      ourPackages: 'Our Packages',
      locations: 'Locations',
      contact: 'Contact',
      packagesAndLocations: 'Packages & Locations',
      kranevo: 'Kranevo',
      plovdiv: 'Plovdiv',
      sofiaBoyana: 'Sofia, Boyana',
      sofiaMladost: 'Sofia, Mladost',
      sofiaNsa: 'Sofia, NSA',
      address: '5 Vasil Sokolov street, Floor 1, Plovdiv, Bulgaria',
      copyright: 'Copyright © 2025 Champion Maker, All Rights Reserved',
    },
  },
  ar: {
    header: {
      home: 'الرئيسية',
      aboutUs: 'من نحن',
      ourPackages: 'باقاتنا',
      locations: 'المواقع',
      contact: 'اتصل بنا',
      bookNow: 'احجز الآن',
      allLocations: 'جميع المواقع',
      sofiaMladost: 'صوفيا، ملادوست',
      sofiaNsa: 'صوفيا، الأكاديمية الوطنية',
      plovdiv: 'بلوفديف',
      sofiaBoyana: 'صوفيا، بويانا',
      kranevo: 'كرانييفو',
    },
    footer: {
      championMaker: 'صناع الأبطال',
      description: 'شركة مقرها بلغاريا تتخصص في تنظيم معسكرات التدريب الرياضي في جميع أنحاء البلاد.',
      links: 'روابط',
      aboutUs: 'من نحن',
      ourPackages: 'باقاتنا',
      locations: 'المواقع',
      contact: 'اتصل بنا',
      packagesAndLocations: 'الباقات والمواقع',
      kranevo: 'كرانييفو',
      plovdiv: 'بلوفديف',
      sofiaBoyana: 'صوفيا، بويانا',
      sofiaMladost: 'صوفيا، ملادوست',
      sofiaNsa: 'صوفيا، الأكاديمية الوطنية',
      address: '5 شارع فاسيل سوكولوف، الطابق 1، بلوفديف، بلغاريا',
      copyright: 'جميع الحقوق محفوظة © 2025 صناع الأبطال',
    },
  },
};
